'use strict';

document.addEventListener('DOMContentLoaded', function () {
    var
    // ----------------------------------------------------------
    // FUNCTIONS ------------------------------------------------
    // ----------------------------------------------------------
    showBtnGroup  = function() {
        var elGroup     = jQuery('div[data-autohide]')
        ;
        if( elGroup) {
            //DEFAULT :  Hide buttons group
            elGroup.find( elGroup.attr('data-autohide') )
                .css({ 'opacity': 0 });
            //EVENTS :  Show/Hide buttons group
            elGroup.on({
                mouseenter: function() {
                    jQuery(this).find( jQuery(this).attr('data-autohide') )
                        .css({ 'opacity': 1 });
                },
                mouseleave: function() {
                    jQuery(this).find( jQuery(this).attr('data-autohide') )
                        .css({ 'opacity': 0 });
                }
            });
        }
    }
    ;

    // ----------------------------------------------------------------
    // APPLY FUNCTIONS ------------------------------------------------
    // ----------------------------------------------------------------
    showBtnGroup();
});
